module.exports = __webpack_public_path__ + "img/collectivibe-logo.967d5f44.png";